import { EmployeeSummary, Timeframe } from "@performyard/service-contracts";

import { PYUseQueryOptions } from "../../../api/hooks/StandardQueryArguments";

import { fetchEmployeeSummary } from "../../../api/services/defs/internal-api";

export const employeeSummaryQuery = (
	userId: string,
	timeframe: Timeframe,
	options?: PYUseQueryOptions<EmployeeSummary>
) => ({
	...options,
	queryKey: ["EmployeeSummary", userId, timeframe],
	queryFn: () => fetchEmployeeSummary(userId, timeframe),
	meta: {
		errorMessage: "There was an error loading employee insights.",
	},
});
